export default __webpack_public_path__ + "static/media/young_and_old_2.ca9ff348.svg";